// Extra i18n keys for the AI installment confirmation modal.
export const EXTRA_AI = {
  en: {
    installmentDetected: "Installment plan detected",
    reviewBeforeSave: "Review the plan before saving",
    totalAmount: "Total amount", remainingAmount: "Remaining amount",
    endDate: "End date", monthlyAmount: "Monthly amount",
    paidAmount: "Paid so far",
    dataMismatch: "There is a mismatch in the plan you described",
    errTotal: "Total amount doesn't match monthly × total installments",
    errEnd: "End date doesn't match start + total installments",
    errMissing: "Missing required info",
    warnRemain: "Remaining amount doesn't perfectly match paid × monthly",
    fixSuggested: "Suggested", provided: "You said",
    confirmSave: "Save installment",
  },
  ar: {
    installmentDetected: "تم اكتشاف خطة قسط",
    reviewBeforeSave: "راجع البيانات قبل الحفظ",
    totalAmount: "المبلغ الإجمالي", remainingAmount: "المبلغ المتبقي",
    endDate: "تاريخ الانتهاء", monthlyAmount: "القسط الشهري",
    paidAmount: "المدفوع",
    dataMismatch: "توجد أخطاء في تفاصيل الخطة التي أدخلتها",
    errTotal: "المبلغ الإجمالي لا يطابق (القسط × عدد الأقساط)",
    errEnd: "تاريخ الانتهاء لا يطابق (تاريخ البداية + عدد الأقساط)",
    errMissing: "بيانات مطلوبة غير مكتملة",
    warnRemain: "المبلغ المتبقي لا يطابق تماماً (المدفوع × القسط)",
    fixSuggested: "المقترح", provided: "قلت",
    confirmSave: "احفظ القسط",
  },
};
